import { UsageStatisticsPeriod } from "../../http/types/usageStatistics";

// The backend's cap, both days included.
export const MAX_PERIOD_DAYS = 366;
export const DEFAULT_PERIOD_DAYS = 30;

// The users of an app or a module (its key) on a UTC day.
export type DailyStatistic = { date: string; key: string; users: number };

// Days are 'YYYY-MM-DD' in UTC, like the statistics: as strings they also compare chronologically.
export const todayUtc = () => new Date().toISOString().slice(0, 10);

export const addDays = (day: string, days: number) => {
  const date = new Date(`${day}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};

// Every day of the period, the oldest first.
export const getPeriodDays = ({ from, to }: UsageStatisticsPeriod): string[] => {
  const days: string[] = [];
  for (let day = from; day <= to; day = addDays(day, 1)) {
    days.push(day);
  }
  return days;
};

// A day as a chart x value: the Unix time of its UTC midnight, in seconds.
export const dayToUnixTime = (day: string) => Date.parse(`${day}T00:00:00Z`) / 1000;

export const unixTimeToDay = (unixTime: number) => new Date(unixTime * 1000).toISOString().slice(0, 10);

// Per key, its users on each day: the statistics only have the days with activity, the others are 0.
export const getDailyUsers = (days: string[], statistics: DailyStatistic[]): Map<string, number[]> => {
  const dayIndexes = new Map(days.map((day, index) => [day, index]));
  const usersByKey = new Map<string, number[]>();

  statistics.forEach(({ date, key, users }) => {
    const index = dayIndexes.get(date);
    if (index === undefined) {
      return;
    }

    let values = usersByKey.get(key);
    if (!values) {
      values = new Array<number>(days.length).fill(0);
      usersByKey.set(key, values);
    }
    values[index] = users;
  });

  return usersByKey;
};
